import { render, staticRenderFns } from "./DrawerPerfil.vue?vue&type=template&id=4a784a1a&scoped=true&"
import script from "./DrawerPerfil.vue?vue&type=script&lang=js&"
export * from "./DrawerPerfil.vue?vue&type=script&lang=js&"
import style0 from "./DrawerPerfil.vue?vue&type=style&index=0&id=4a784a1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a784a1a",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerCube from 'quasar/src/components/spinner/QSpinnerCube.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QBtn,QSpinnerCube,QSelect,QInput,QIcon,QCardActions,QTooltip,QList,QItem,QItemSection,QSeparator,QToggle});qInstall(component, 'directives', {Ripple});
